import { useState, useEffect } from 'react';
import ComponentNotifier from '../../../../services/wss/ComponentNotifier';
import noteOptionsPanelEngine from './NoteOptionsPanelEngine';

const _name = 'NoteOptionsPanelEngine';

/**
 * useNoteOptionsPanel
 * Hook for ContentPanel and NoteOptionsPanel — subscribes to NoteOptionsPanelEngine state changes.
 * Filters on panelId so each panel only repaints when its own state changes.
 * @param {string} [panelId='default']
 */
export function useNoteOptionsPanel(panelId = 'default') {
    const [state, setState] = useState(() => {
        const p = noteOptionsPanelEngine.getState(panelId);
        return {
            viewMode:    p.viewMode,
            bgMode:      p.bgMode,
            inFocusMode: p.inFocusMode,
            isEditing:   p.isEditing,
            draftBody:   p.draftBody,
            deleteOpen:  p.deleteOpen,
            newNoteOpen: p.newNoteOpen,
            newNotePos:  p.newNotePos,
        };
    });

    useEffect(() => {
        const unsub = ComponentNotifier.subscribe(_name, (e) => {
            if (e.target !== 'stateChanged') return;
            if (e.data?.panelId !== panelId) return;
            const d = e.data;
            setState({
                viewMode:    d.viewMode,
                bgMode:      d.bgMode,
                inFocusMode: d.inFocusMode,
                isEditing:   d.isEditing,
                draftBody:   d.draftBody,
                deleteOpen:  d.deleteOpen,
                newNoteOpen: d.newNoteOpen,
                newNotePos:  d.newNotePos,
            });
        });
        return () => unsub?.();
    }, [panelId]);

    return { engine: noteOptionsPanelEngine, ...state };
}
